import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const MobileAssetModalPanel = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("section", {
        className: "flex size-full flex-col",
        children: children
    });
});
MobileAssetModalPanel.displayName = "MobileAssetModalPanel";
